import React from "react";
import {
  TextField as MuiTextField,
  styled,
  Stack,
  Typography,
  StandardTextFieldProps
} from "@mui/material";
export interface TextFieldProps extends StandardTextFieldProps {
  subLabel?: string;
  boldLabel?: boolean;
}
export default styled((props: TextFieldProps) => {
  const { boldLabel, subLabel, label, ...textFieldProps } = props;
  return (
    <Stack spacing={0.5} width="100%">
      {label
        ? <Typography variant="body1" fontWeight={boldLabel ? 600 : 400}>
            {label}
            {subLabel
              ? <span style={{ fontWeight: 400 }}>
                  {subLabel}
                </span>
              : null}
          </Typography>
        : null}
      <MuiTextField
        {...textFieldProps}
        InputLabelProps={{
          color: "secondary",
          disableAnimation: true,
          shrink: true
        }}
      />
    </Stack>
  );
})({
  fontWeight: 400,
  fontSize: 14,
  border: 0,
  padding: 0,
  "& .MuiInput-input": {
    padding: 10
  },
  "& .MuiInputBase-root": {
    height: "100%",
    borderRadius: "15px",
    fontSize: 16
  },
  "& .MuiSelect-select": {
    padding: `17px 14px`,
    "&:focus": {
      background: "none"
    }
  }
});
